import "./styles.css";
import { Box, Grid, Container, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import OtpVerification from "./components/otpVerification";
import Login from "./components/login";
import GcomLogo from "../../../src/assets/img/dashboard-title.svg";
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [qrCodeSrc, setQrCodeSrc] = useState<string | null>(null);

  const navigationType = useNavigationType(); // "POP" | "PUSH" | "REPLACE"

  useEffect(() => {
    if (navigationType === "POP") {
      console.log("User pressed BACK/FORWARD");
      navigate('/login', {replace: true});
    }
  }, [location, navigationType]);

  return (
    <Container maxWidth="xl">
      {/* Top bar with logo aligned to right */}
      <Box className="menuContainer" sx={{ padding: "0.5rem 1.2rem" }}>
        <Grid container justifyContent="flex-end" alignItems="center">
          <Grid item>
            <img src={GcomLogo} alt="Gcom Logo" style={{ height: "30px" }} />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ padding: "0 2rem", marginTop: 7, textAlign: "left", marginInline: 5,  }}>
        <Typography
          sx={{
            fontSize: { xs: "46px", md: "46px" },
            color: "#25353D",
            fontWeight: 700,
          }}
        >
          Let’s sign you in.
        </Typography>
        <Typography
          // variant="subtitle1"          
          color="textSecondary"
          sx={{ 
            whiteSpace: "pre-line", 
            lineHeight: 1.5, 
            marginTop: 1, 
            marginBottom: 3,
            fontWeight: 400, 
            color: "#43463B",
            fontSize: { xs: "13px", md: "13px" },
          }}
        >
          Enter your credentials to unlock the full GCommerce {"\n"} experience.
        </Typography>
      {/* </Box> */}
      {/* Login / OTP Section */}
      {/* <Box sx={{ marginTop: 3 }} className="loginFormBox"> */}
        {qrCodeSrc ? (
          <OtpVerification qrCodeSrc={qrCodeSrc} />
        ) : (
          <Login setQrCodeSrc={setQrCodeSrc} />
        )}
      </Box>
    </Container>
  );
};

export default App;
